import React, { useEffect, useState } from "react";
import { BsEye } from "react-icons/bs";
import { MdEdit } from "react-icons/md";
import Input from "../../components/input";
import { Link, useSearchParams } from "react-router-dom";
import { toast } from "react-toastify";
import useAxiosInstance from "../../hooks/useAxios";
import { useDebounce } from "use-debounce";
import DropDownComponent from "../../components/DropdownComp";
import { useSelector } from "react-redux";
import { envWiseAppUrl } from "../../const";
import { detectIncognito } from "detectincognitojs";

const AllUsers = () => {
  const { accountType, allOrgProfileTypes } = useSelector((e) => e.globalAuth);
  const { username: currentUsername } = useSelector((e) => e.auth);
  const [selectedAccountType, setSelectedAccountType] = useState([]);
  const [selectedUserAccountType, setSelectedUserAccountType] = useState([]);

  const [userActiveInactiveStatus, setUserActiveInactiveStatus] =
    useState("all");
  const [searchParams, setSearchParams] = useSearchParams();
  const [AllOrganisation, setAllOrganisation] = useState([]);
  const [searchOrg, setSearchOrg] = useState("");
  const [orgLoading, setOrgLoading] = useState(false);
  const [selectedOrg, setSelectedOrg] = useState([]);
  const [orgIdToUserMappning, SetOrgIdToUserMappning] = useState({});

  const [userList, setUserList] = useState([]);
  const [userSearch, setUserSearch] = useState("");
  const [userQuery] = useDebounce(userSearch, 1000);
  const [
    userPaginatedIntermidatePageNumber,
    setUserPaginatedIntermidatePageNumber,
  ] = useState(1);
  const [userPaginatedPageNumber, setUserPaginatedPageNumber] = useState(1);
  const [isUserListLoading, setIsUserListLoading] = useState(false);
  const [logoutLoading, setLogoutLoading] = useState(false);
  const [selectedUserId, setSelectedUserId] = useState([]);
  const [orgProfileType, setOrgProfieType] = useState("all");
  const [enableLoginOption, setEnableLoginOption] = useState(false);
  const [includeExpired, setIncludeExpired] = useState(false);

  // Select all handlers for organizations table
  const handleSelectAllOrgs = (checked) => {
    if (checked) {
      const filteredOrgs = getFilteredOrgs(AllOrganisation, searchOrg) || [];
      const allOrgIds = filteredOrgs.map((org) => org.org_id);
      setSelectedOrg(allOrgIds);
    } else {
      setSelectedOrg([]);
    }
  };

  // Select all handlers for users table
  const handleSelectAllUsers = (checked) => {
    if (checked) {
      const allUserIds = userList?.users?.map((user) => user.user_id) || [];
      setSelectedUserId(allUserIds);
    } else {
      setSelectedUserId([]);
    }
  };

  const axiosInstance = useAxiosInstance();

  const getOrgImage = (img, name) => {
    if (img === null || img == "") {
      return `https://wklogo.blob.core.windows.net/logos-small/${name[0]?.toUpperCase()}.png`;
    } else {
      return img;
    }
  };
  const getFilteredOrgs = (AllOrganisation, searchOrg) => {
    if (!searchOrg) {
      return AllOrganisation;
    }
    return AllOrganisation?.filter(
      (item) =>
        item?.name?.toLowerCase().includes(searchOrg?.toLowerCase()) ||
        item?.label?.toLowerCase().includes(searchOrg?.toLowerCase())
    );
  };

  useEffect(() => {
    setOrgLoading(true);
    setSelectedOrg([]);
    const orgTypeParam =
      selectedAccountType.length > 0 ? selectedAccountType.join(",") : "all";
    axiosInstance
      .get(`admin/organisations/?org_type=${orgTypeParam}&include_expired=${includeExpired}`)
      .then((res) => {
        setAllOrganisation(res.data.organisations);
        let orgIdToUserMapping = {};
        res.data.organisations.forEach((org) => {
          orgIdToUserMapping[org.org_id] = org;
        });
        SetOrgIdToUserMappning(orgIdToUserMapping);
        setOrgLoading(false);
      })
      .catch((err) => {
        console.log(err);
        toast.error("Something went while getting orgs");
        setOrgLoading(false);
      });
  }, [selectedAccountType, includeExpired]);

  useEffect(() => {
    setIsUserListLoading(true);
    setSelectedUserId([]);
    // let new_orgs_ids = Object.keys(selectedOrg).map(elem=>Number(elem))
    const controller = new AbortController();
    const userOrgTypeParam =
      selectedUserAccountType.length > 0
        ? selectedUserAccountType.join(",")
        : "all";
    axiosInstance
      .get(
        `/admin/get-org-users/?&pgsz=20&page=${userPaginatedPageNumber}&org_ids=${selectedOrg}&query=${userQuery}&user_active_inactive_filter=${userActiveInactiveStatus}&org_type=${selectedUserAccountType}&org_profile_type=${orgProfileType}&include_expired=${includeExpired}`,
        {
          signal: controller.signal,
        }
      )
      .then((res) => {
        setUserList(res.data);
        setIsUserListLoading(false);
        setUserPaginatedIntermidatePageNumber(res.data.current_page);
      })
      .catch((err) => {
        console.log(err);
        // toast.error("Something went while getting users");
        // setIsUserListLoading(false);
      });

    return () => {
      controller.abort();
    };
  }, [
    userPaginatedPageNumber,
    userQuery,
    selectedOrg,
    userActiveInactiveStatus,
    selectedUserAccountType,
    orgProfileType,
    includeExpired,
  ]);

  const handleLogout = (list, type) => {
    setLogoutLoading(true);
    axiosInstance
      .post("accounts/logout_n_users_or_orgs/", {
        type: type,
        id_or_name: list,
      })
      .then((res) => {
        setLogoutLoading(false);
        if (res.data.status === "success") {
          toast.success("Logout successful");
        }
      })
      .catch((err) => {
        toast.error("Logout failed");
        setLogoutLoading(false);
        console.log(err);
      });
  };

  const handleLoginAs = (id, username) => {
    detectIncognito().then((result) => {
      // console.log(result.browserName, result.isPrivate);
      if (!result.isPrivate) {
        toast.error("Please use incognito browser to use this functionality");
        return;
      }

      const input = window.prompt(`To confirm, type the username: ${username}`);
      if (input !== username) {
        toast.error("Username does not match. Action cancelled.");
        return;
      }

      const env = localStorage.getItem("sandbox-env");

      setLogoutLoading(true);
      axiosInstance
        .post(
          "accounts/sandbox-impersonate/",
          { user_requested_id: id },
          { withCredentials: true }
        )
        .then((res) => {
          setLogoutLoading(false);
          if (res.data.access_token) {
            toast.success("Login successful");
            window.open(
              `${envWiseAppUrl[env]}/postauth/saml?originaluser=${currentUsername}&loggedinuser=${username}&sessionid=${res.data.session_id}`,
              "_blank"
            );
          }
        })
        .catch((err) => {
          toast.error("Login failed");
          setLogoutLoading(false);
          console.log(err);
        });
    });
  };

  const [fullDeactivationLoading, setFullDeactivationLoading] = useState(false);
  const [semiDeactivationLoading, setSemiDeactivationLoading] = useState(false);

  const handleDeactivation = (setLoader, user_ids, mode) => {
    setLoader(true);
    axiosInstance
      .post("accounts/sandbox_user_deactivation/", {
        mode: mode,
        user_ids: user_ids,
        active_or_not_active: false,
      })
      .then((res) => {
        setLoader(false);
        if (res.data.status === "success") {
          toast.success("successful");
        }
      })
      .catch((err) => {
        toast.error("failed");
        setLoader(false);
        console.log(err);
      });
  };

  const [isXLSXDownloading, setIsXLSXDownloading] = useState(false);

  const handleXLSXDownload = async () => {
    setIsXLSXDownloading(true);
    const filterObj = {
      user_id: "",
      enable_zero_report_users: true,
      view_org_size: 30,
      view_user_size: 9999999999,
      view_report_size: 30,
      org_ids: selectedOrg.join(","),
    };
    filterObj["user_resource_to_show"] = "filtered_users";
    await axiosInstance(`/admin/export_org_users/`, {
      method: "GET",
      responseType: "blob",
      headers: {
        "Content-Type": "application/json",
      },
      params: { ...filterObj, required_items: "user_list" },
    })
      .then((response) => {
        setIsXLSXDownloading(false);
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", `List of users.xlsx`);
        document.body.appendChild(link);
        link.click();
      })
      .catch((err) => {
        setIsXLSXDownloading(false);
      });
  };
  return (
    <div className="w-full p-6">
      <div className="text-2xl font-semibold">
        {" "}
        {searchParams.get("page") || " User Management"}
      </div>
      {
        <div className="mt-4">
          <div className="flex items-center justify-between w-full">
            <p className="mb-4 text-sm font-semibold">All Users</p>

            {!searchParams.get("page") && (
              <div className="flex items-center gap-x-2">
                <label className="flex items-center text-sm gap-x-1">
                  <input
                    type="checkbox"
                    checked={includeExpired}
                    onChange={(e) => setIncludeExpired(e.target.checked)}
                  />
                  <span>Include Expired</span>
                </label>
                <button
                  onClick={() => {
                    handleLogout(selectedOrg, "org");
                  }}
                  disabled={logoutLoading}
                  className="px-2 py-1 text-sm text-white bg-black disabled:cursor-not-allowed rounded-xl"
                >
                  {logoutLoading ? "loading" : "Logout selected Orgs"}
                </button>
              </div>
            )}
          </div>

          {/* <input pla/> */}
          <Input
            className="w-full"
            placeholder="Search orgs"
            value={searchOrg}
            onChange={(e) => setSearchOrg(e.target.value)}
          />

          {orgLoading && <p className="mt-4">Loading orgs...</p>}
          {!orgLoading && (
            <div className="overflow-x-auto h-[300px]  overflow-y-auto mt-4 border rounded-lg">
              <table className="w-full">
                <thead className="text-left border-b">
                  <th className="px-2 py-1 text-sm text-gray-700">
                    <input
                      type="checkbox"
                      checked={
                        getFilteredOrgs(AllOrganisation, searchOrg)?.length >
                          0 &&
                        getFilteredOrgs(AllOrganisation, searchOrg)?.every(
                          (org) => selectedOrg.includes(org.org_id)
                        )
                      }
                      onChange={(e) => handleSelectAllOrgs(e.target.checked)}
                    />
                  </th>
                  <th className="px-2 py-1 text-sm text-gray-700">Name</th>
                  <th className="px-2 py-1 text-sm text-gray-700">Image</th>
                  <th className="px-2 py-1 text-sm text-gray-700">Logo</th>
                  <th className="px-2 py-1 text-sm text-gray-700">ID</th>
                  <th className="px-2 py-1 text-sm text-gray-700">Label</th>
                  <th className="px-2 py-1 text-sm text-gray-700 gap-x-2">
                    <div className="flex whitespace-nowrap gap-x-2">
                      <button>Account Type </button>
                      <DropDownComponent
                        options={["all", ...accountType.map((at) => at?.label)]}
                        sortBy={selectedAccountType}
                        setSortBy={(value) => {
                          if (value === "all") {
                            setSelectedAccountType([]);
                          } else {
                            if (selectedAccountType.includes(value)) {
                              setSelectedAccountType(
                                selectedAccountType.filter(
                                  (item) => item !== value
                                )
                              );
                            } else {
                              setSelectedAccountType([
                                ...selectedAccountType,
                                value,
                              ]);
                            }
                          }
                        }}
                        defaultValue={[]}
                        isMultiSelect={true}
                      />
                    </div>
                  </th>
                  <th className="px-2 py-1 text-sm text-gray-700">
                    Report Count
                  </th>
                </thead>
                <tbody className="divide-y">
                  {(getFilteredOrgs(AllOrganisation, searchOrg) || []).map(
                    (org, index) => {
                      return (
                        <tr key={index} className="bg-white odd:bg-gray-50">
                          <td className="px-2 py-1 text-gray-900 whitespace-nowrap">
                            {/* <button className='p-2 text-xl text-white bg-yellow-200 rounded-xl'><MdEdit/></button> */}
                            <input
                              type="checkbox"
                              checked={selectedOrg.includes(org.org_id)}
                              onClick={() =>
                                selectedOrg.includes(org.org_id)
                                  ? setSelectedOrg((prev) =>
                                      prev.filter((item) => item != org.org_id)
                                    )
                                  : setSelectedOrg((prev) => [
                                      ...prev,
                                      org.org_id,
                                    ])
                              }
                            />
                          </td>
                          <td className="px-2 py-1 text-gray-900 whitespace-nowrap">
                            {org.name}
                          </td>
                          <td className="px-2 py-1 text-gray-900 whitespace-nowrap">
                            <div
                              style={{
                                backgroundImage: `url('${getOrgImage(
                                  org?.org_img,
                                  org?.name
                                )}')`,
                              }}
                              className="h-[30px] w-full bg-center bg-no-repeat bg-contain"
                            />
                          </td>
                          <td className="px-2 py-1 text-gray-900 whitespace-nowrap">
                            <div
                              style={{
                                backgroundImage: `url('${getOrgImage(
                                  org?.org_logo,
                                  org?.name
                                )}')`,
                              }}
                              className="h-[30px] w-full bg-center bg-no-repeat bg-contain"
                            />
                          </td>
                          <td className="px-2 py-1 text-gray-900 whitespace-nowrap">
                            {org.org_id}
                          </td>
                          <td className="px-2 py-1 text-gray-900 whitespace-nowrap">
                            {org.label}
                          </td>
                          <td className="px-2 py-1 text-gray-900 whitespace-nowrap">
                            {org?.account_type?.name}
                          </td>
                          <td className="px-2 py-1 text-gray-900 whitespace-nowrap">
                            {org?.report_count}
                          </td>
                        </tr>
                      );
                    }
                  )}
                </tbody>
              </table>
            </div>
          )}
        </div>
      }
      <div className="mt-4">
        <div className="flex items-center justify-end mb-2 gap-x-2">
          {!searchParams.get("page") && (
            <>
              <button
                onClick={() => {
                  handleDeactivation(
                    setSemiDeactivationLoading,
                    selectedUserId,
                    "profile"
                  );
                }}
                disabled={semiDeactivationLoading}
                className="px-2 py-1 text-sm text-white bg-black disabled:bg-gray-200 disabled:text-black disabled:cursor-not-allowed rounded-xl"
              >
                {semiDeactivationLoading ? "loading" : "Semi Deactivation"}
              </button>

              <button
                onClick={() => {
                  handleDeactivation(
                    setFullDeactivationLoading,
                    selectedUserId,
                    "user"
                  );
                }}
                disabled={fullDeactivationLoading}
                className="px-2 py-1 text-sm text-white bg-black disabled:bg-gray-200 disabled:text-black disabled:cursor-not-allowed rounded-xl"
              >
                {fullDeactivationLoading ? "loading" : "Full Deactivation"}
              </button>

              <button
                onClick={() => {
                  handleLogout(selectedUserId, "user");
                }}
                disabled={logoutLoading}
                className="px-2 py-1 text-sm text-white bg-black disabled:cursor-not-allowed rounded-xl"
              >
                {logoutLoading ? "loading" : "Logout selected Users"}
              </button>

              <button
                onClick={() => {
                  setEnableLoginOption(!enableLoginOption);
                }}
                disabled={logoutLoading}
                className="px-2 py-1 text-sm text-white bg-black disabled:cursor-not-allowed rounded-xl"
              >
                Enable login option
              </button>

              <button
                onClick={() => {
                  handleXLSXDownload();
                }}
                disabled={isXLSXDownloading}
                className="px-2 py-1 text-sm text-white bg-black disabled:cursor-not-allowed rounded-xl"
              >
                {isXLSXDownloading ? "loading" : "Export Users"}
              </button>
            </>
          )}
        </div>
        <Input
          value={userSearch}
          onChange={(e) => {
            setUserSearch(e.target.value);
          }}
          type="text"
          placeholder="Search User"
        />
        <div className="overflow-y-auto h-[70vh] mt-2 border  rounded-lg w-full">
          <table className="w-full ">
            <thead className="text-left border-b">
              <th className="px-2 py-1 text-sm text-gray-700 ">
                <input
                  type="checkbox"
                  checked={
                    userList?.users?.length > 0 &&
                    userList?.users?.every((user) =>
                      selectedUserId.includes(user.user_id)
                    )
                  }
                  onChange={(e) => handleSelectAllUsers(e.target.checked)}
                />
              </th>
              <th className="px-2 py-1 text-sm text-gray-700 ">UserName</th>
              <th className="px-2 py-1 text-sm text-gray-700 ">
                <div className="flex whitespace-nowrap gap-x-1">
                  <p>Role</p>
                  <DropDownComponent
                    options={[
                      "all",
                      ...allOrgProfileTypes.map((at) => at?.value),
                    ]}
                    sortBy={orgProfileType}
                    setSortBy={setOrgProfieType}
                    defaultValue="all"
                  />
                </div>
              </th>
              <th className="px-2 py-1 text-sm text-gray-700 ">
                <div className="flex whitespace-nowrap gap-x-2">
                  <p>Active/Inactive</p>{" "}
                  <DropDownComponent
                    options={["all", "active", "inactive"]}
                    sortBy={userActiveInactiveStatus}
                    setSortBy={setUserActiveInactiveStatus}
                    defaultValue="all"
                  />
                </div>
              </th>
              <th className="px-2 py-1 text-sm text-gray-700 ">First Name</th>
              <th className="px-2 py-1 text-sm text-gray-700 ">Last Name</th>
              <th className="px-2 py-1 text-sm text-gray-700 ">Org Name</th>
              <th className="px-2 py-1 text-sm text-gray-700 ">
                <div className="flex whitespace-nowrap gap-x-1">
                  <p>Org Type</p>
                  <DropDownComponent
                    options={["all", ...accountType.map((at) => at?.label)]}
                    sortBy={selectedUserAccountType}
                    setSortBy={(value) => {
                      if (value === "all") {
                        setSelectedUserAccountType([]);
                      } else {
                        if (selectedUserAccountType.includes(value)) {
                          setSelectedUserAccountType(
                            selectedUserAccountType.filter(
                              (item) => item !== value
                            )
                          );
                        } else {
                          setSelectedUserAccountType([
                            ...selectedUserAccountType,
                            value,
                          ]);
                        }
                      }
                    }}
                    defaultValue={[]}
                    isMultiSelect={true}
                  />
                </div>
              </th>
              <th className="px-2 py-1 text-sm text-gray-700 ">
                Newsletter POC
              </th>
              <th className="px-2 py-1 text-sm text-gray-700 ">
                Preferred notebook language
              </th>
              {enableLoginOption && (
                <th className="px-2 py-1 text-sm text-gray-700 ">Login as</th>
              )}
            </thead>
            <tbody className="divide-y">
              {isUserListLoading ? (
                <div className="flex flex-col items-center justify-center">
                  <p>Loading...</p>
                </div>
              ) : (
                userList?.users?.map((user) => {
                  return (
                    <tr className="bg-white odd:bg-gray-50" key={user.user_id}>
                      <td className="px-2 py-2 text-gray-900 whitespace-nowrap">
                        {/* <button className='p-2 text-xl text-white bg-yellow-200 rounded-xl'><MdEdit/></button> */}
                        <Link
                          to={
                            searchParams.get("page")
                              ? `/preferencesDetailedView?user_id=${
                                  user.user_id
                                }&user_email=${user.username}&org_name=${
                                  user.org_id
                                }&user_type=${
                                  orgIdToUserMappning[user.org_id]
                                    ?.account_type === "admin"
                                    ? "admin_org_products"
                                    : "user_org_products"
                                }`
                              : `/editUsers/?user_id=${user.user_id}`
                          }
                        >
                          <button className="p-2 text-xl text-white bg-black rounded-xl">
                            <MdEdit />
                          </button>
                        </Link>

                        <input
                          type="checkbox"
                          className="ml-2"
                          checked={selectedUserId.includes(user.user_id)}
                          onClick={() => {
                            selectedUserId.includes(user.user_id)
                              ? setSelectedUserId((prev) =>
                                  prev.filter((it) => it != user.user_id)
                                )
                              : setSelectedUserId((prev) => [
                                  ...prev,
                                  user.user_id,
                                ]);
                          }}
                        />
                      </td>
                      <td className="px-2 py-2 font-medium text-gray-900 whitespace-nowrap">
                        {user.username}
                      </td>
                      <td className="px-2 py-2 font-medium text-gray-900 whitespace-nowrap">
                        {user.org_profile_type}
                      </td>
                      <td className="px-2 py-2 font-medium text-gray-900 whitespace-nowrap">
                        {user.active ? "active" : "inactive"}
                      </td>
                      <td className="px-2 py-2 font-medium text-gray-900 whitespace-nowrap">
                        {user.first_name}
                      </td>
                      <td className="px-2 py-2 font-medium text-gray-900 whitespace-nowrap">
                        {user.last_name}
                      </td>
                      <td className="px-2 py-2 font-medium text-gray-900 whitespace-nowrap">
                        {user.org_name ||
                          orgIdToUserMappning[user.org_id]?.name ||
                          "not known"}
                      </td>
                      <td className="px-2 py-2 font-medium text-gray-900 whitespace-nowrap">
                        {user.org_account_type ||
                          orgIdToUserMappning[user.org_id]?.account_type
                            ?.name ||
                          "not known"}
                      </td>
                      <td className="px-2 py-2 font-medium text-gray-900 whitespace-nowrap">
                        {`${user.is_newsletter_poc}`}
                      </td>
                      <td className="px-2 py-2 font-medium text-gray-900 whitespace-nowrap">
                        {user.preferred_notebook_language}
                      </td>
                      {enableLoginOption && (
                        <td
                          onClick={() =>
                            handleLoginAs(user.user_id, user.username)
                          }
                          className="text-red-500 cursor-pointer"
                        >
                          Login
                        </td>
                      )}
                    </tr>
                  );
                })
              )}
            </tbody>
          </table>
        </div>
        <div className="flex items-center justify-between mt-2">
          <div className="flex items-center space-x-1">
            {userList.current_page > 1 && (
              <button
                disabled={isUserListLoading}
                onClick={() => {
                  setUserPaginatedPageNumber((prev) => prev - 1);
                }}
                className="px-0 py-0 text-black underline rounded-lg disabled:cursor-not-allowed"
              >
                Back
              </button>
            )}

            <div className="flex items-center p-1 space-x-1 border-2 border-black rounded">
              <input
                value={
                  isUserListLoading
                    ? "loading..."
                    : userPaginatedIntermidatePageNumber
                }
                type="number"
                className="w-10 mx-2 disabled:cursor-not-allowed"
                disabled={isUserListLoading}
                onChange={(e) => {
                  setUserPaginatedIntermidatePageNumber(Number(e.target.value));
                }}
              />
              <button
                onClick={() => {
                  if (
                    userPaginatedIntermidatePageNumber > 0 &&
                    userPaginatedIntermidatePageNumber <= userList.num_pages
                  ) {
                    setUserPaginatedPageNumber(
                      userPaginatedIntermidatePageNumber
                    );
                  } else {
                    alert("Please enter correct number range");
                  }
                }}
                className="px-1 py-1 text-xs text-white bg-black rounded"
              >
                Apply
              </button>
            </div>
            {userList.current_page < userList.num_pages && (
              <button
                disabled={isUserListLoading}
                onClick={() => {
                  setUserPaginatedPageNumber((prev) => prev + 1);
                }}
                className="px-0 py-0 ml-3 text-black underline rounded-lg disabled:cursor-not-allowed"
              >
                Next
              </button>
            )}
          </div>
          <div className="flex space-x-1">
            <div>Total Pages: {userList.num_pages}</div>
            <div>Filtered Users Count: {userList.len_filtered_results}</div>
            <div>Total Users: {userList.total_users}</div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AllUsers;
